import SettingSwitch from './SettingSwitch';

export default SettingSwitch;
